import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';



export function getCrucigramaPalabrasListSuccess(crucigramapalabras) {
  return {type: types.LOAD_CRUCIGRAMAPALABRAS_LIST_SUCCESS, crucigramapalabras};
}



export function getCrucigramaPalabrasList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CrucigramaPalabrasApi.getCrucigramaPalabrasList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(crucigramapalabras => {                  
                  dispatch(getCrucigramaPalabrasListSuccess(crucigramapalabras));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}

export function getCrucigramaSuccess(crucigramapalabras) {
  return {type: types.LOAD_CRUCIGRAMA_PALABRAS_SUCCESS, crucigramapalabras};
}

export function getCrucigrama(id, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CrucigramaPalabrasApi.getCrucigrama(id, token).then(crucigramapalabras => {                  
                  dispatch(getCrucigramaSuccess(crucigramapalabras));
                  //console.log("crucigramapalabras");
                  //console.log(crucigramapalabras);
                  return crucigramapalabras;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getCrucigramaPalabrasSuccess(catalogo) {
  return {type: types.LOAD_CRUCIGRAMAPALABRAS_SUCCESS, catalogo};
}

export function getCrucigramaPalabras(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().CrucigramaPalabrasApi.getCrucigramaPalabras(id, token).then(crucigramapalabras => {   
        dispatch(getCrucigramaPalabrasSuccess(crucigramapalabras));
        return crucigramapalabras;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(crucigramapalabras) {
  return {type: types.SAVE_CRUCIGRAMAPALABRAS_SUCCESS, crucigramapalabras};
}


export function save(crucigramapalabras, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CrucigramaPalabrasApi.save(crucigramapalabras, token).then(crucigramapalabrasGuardado => {   
        dispatch(saveSuccess(crucigramapalabrasGuardado));
        return crucigramapalabrasGuardado;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function savePosition(crucigramapalabras, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CrucigramaPalabrasApi.savePosition(crucigramapalabras, token).then(crucigramapalabrasGuardado => {   
        dispatch(saveSuccess(crucigramapalabrasGuardado));
        return crucigramapalabrasGuardado;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function getCrucigramaPalabrasComboSuccess(datos) {
  return {type: types.GET_CRUCIGRAMAPALABRASS_COMBO_SUCCESS, datos};
}

export function getCrucigramaPalabrasCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().CrucigramaPalabrasApi.getCrucigramaPalabrasCombo(token).then(datos => {   
        
      dispatch(getCrucigramaPalabrasComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(crucigramapalabras) {
  return {type: types.BORRAR_CRUCIGRAMAPALABRAS_SUCCESS, crucigramapalabras};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CrucigramaPalabrasApi.borrar(id, token ).then(crucigramapalabras => {
               
                  dispatch(borrarSuccess(crucigramapalabras));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(crucigramapalabras) {
  return {type: types.ACTIVAR_CRUCIGRAMAPALABRAS_SUCCESS, crucigramapalabras};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CrucigramaPalabrasApi.activar(id, token).then(crucigramapalabras => {
               
                  dispatch(activarSuccess(crucigramapalabras));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_CRUCIGRAMAPALABRAS, filtro};
}



